'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const components_patterns_ServiceIconShell_ServiceIconShell = require('../ServiceIconShell/ServiceIconShell.cjs.js');

const serviceIconNumeric = "_service-icon-numeric_1ldi5_1";
const styles = {
	serviceIconNumeric: serviceIconNumeric
};

const PDLFontMap = (iconSize, collapsedIconCount) => {
  switch (iconSize) {
    case "small":
      return "--zds-small-print-3";
    case "medium":
    case "large":
      return collapsedIconCount <= 9 ? "--zds-paragraph-header-3" : "--zds-body-3";
    default:
      return "--zds-paragraph-header-3";
  }
};
const ServiceIconNumeric = (props) => {
  const { size, hasBorder = true, hasWhiteBackground } = props;
  const label = `Plus ${props.number} more apps.`;
  const text = props.number > 99 ? `99+` : `+${props.number}`;
  const font = PDLFontMap(size, props.number);
  return jsxRuntime.jsx(components_patterns_ServiceIconShell_ServiceIconShell.ServiceIconShell, { size, hasBorder, hasWhiteBackground, children: jsxRuntime.jsx("span", { "aria-label": label, className: styles.serviceIconNumeric, style: {
    font: `var(${font})`
  }, role: "img", "data-zds": true, children: jsxRuntime.jsx("span", { "aria-hidden": "true", "data-zds": true, children: text }) }) });
};

exports.ServiceIconNumeric = ServiceIconNumeric;
//# sourceMappingURL=ServiceIconNumeric.cjs.js.map
